export default {"src":"/_next/static/media/cix.aa89976b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};